import React from 'react';
import { useTranslation } from 'react-i18next';
import './VideoSection.scss';

const VideoSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="video-section">
      <div className="container">
        <h2 className="video-title">{t('video.title')}</h2>
        <div className="video-container">
          <div className="video-placeholder">
            <div className="play-button">
              <span className="play-icon">▶</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoSection;
